$('.cashmere-image-slider_items-list').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    responsive: [
        {
            breakpoint: 749,
            settings: 'unslick'
        }
    ]
});
$('.legacy-looks-image-slider_items-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true
});
$('.image-slider_items-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true
});

$('.our-story_content-readmore').click(function(e){
    e.preventDefault();
   $('.our-story_content-default_text').hide();
   $('.our-story_content-readmore_text').show();
});
$('.our-story_content-readless').click(function(e){
   e.preventDefault();
   $('.our-story_content-default_text').show();
   $('.our-story_content-readmore_text').hide();
});

$('.product-meta-accordion_title').click(function(){
    $(this).toggleClass('active');
   $(this).next('.product-meta-accordion_content').slideToggle(); 
});

$('.vm_megamenu_right_slider').each(function () {
        var _this = $(this);
        var slider = $(this).find('.vm_right_trending_slider');

        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            prevArrow: _this.find('.vm_right_slider_btn__prev'),
            nextArrow: _this.find('.vm_right_slider_btn__next')
        });

    });